import * as React from "react";
import { SelectTabData, SelectTabEvent, TabList, Tab, makeStyles } from "@fluentui/react-components";

export type EmailTone = "informale" | "conciso" | "professionale";

interface ToneSelectorProps {
  onToneChange: (tone: EmailTone) => void;
  selectedTone: EmailTone;
}

const useStyles = makeStyles({
  root: {
    marginBottom: "20px",
  },
  tabList: {
    width: "100%",
  },
});

const ToneSelector: React.FC<ToneSelectorProps> = ({ onToneChange, selectedTone }) => {
  const styles = useStyles();

  const onTabSelect = (_: SelectTabEvent, data: SelectTabData) => {
    onToneChange(data.value as EmailTone);
  };

  return (
    <div className={styles.root}>
      <TabList
        className={styles.tabList}
        selectedValue={selectedTone}
        onTabSelect={onTabSelect}
        appearance="subtle"
      >
        <Tab value="informale">Informale</Tab>
        <Tab value="conciso">Sintetico</Tab>
        <Tab value="professionale">Professionale</Tab>
      </TabList>
    </div>
  );
};

export default ToneSelector; 